import "./App.css";

import Landing from "./components/Landing";
function App() {
  return <div>{<Landing />}</div>;
}

export default App;
